import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import confetti from "canvas-confetti";

export default function Success() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowModal(true);
      confetti({
        particleCount: 150,
        spread: 80,
        origin: { y: 0.6 },
        colors: ["#ff00cc", "#39ff14", "#ffffff"],
      });
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        background: "#0a0a0a",
        color: "#eee",
        minHeight: "100vh",
        padding: "60px 20px",
        textAlign: "center",
        fontFamily: "'IBM Plex Sans', sans-serif",
        position: "relative",
      }}
    >
      <h2
        style={{
          fontSize: "28px",
          color: "#ff77cc",
          textShadow: "0 0 10px rgba(255, 0, 170, 0.6)",
          marginBottom: "12px",
        }}
      >
        🎉 You unlocked a piece of my face!
      </h2>

      <p style={{ color: "#aaa", fontSize: "16px", marginBottom: "20px" }}>
        Thank you for revealing a tile — your curiosity is fueling the big reveal.
      </p>

      <div
        style={{
          backgroundColor: "#222",
          color: "#ffccff",
          padding: "10px 16px",
          borderRadius: "8px",
          fontSize: "13px",
          maxWidth: "440px",
          margin: "0 auto 24px auto",
          boxShadow: "0 0 10px rgba(255, 0, 170, 0.2)",
        }}
      >
        🧠 Not every tile purchase reveals something instantly. Your participation fuels the big reveal — and some tiles unlock deep in the background.
      </div>

      <img
        src="/tease.png"
        alt="Blurred Face"
        style={{
          width: "280px",
          height: "auto",
          borderRadius: "12px",
          boxShadow: "0 0 20px rgba(255, 0, 170, 0.4)",
          marginBottom: "20px",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      />

      <p style={{ fontSize: "14px", color: "#888", marginBottom: "40px" }}>
        Want to reveal more? Go back and buy another tile.
      </p>

      <Link to="/">
        <button
          style={{
            backgroundColor: "#ff00aa",
            color: "#fff",
            fontSize: "16px",
            padding: "12px 24px",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            boxShadow: "0 0 10px rgba(255, 0, 170, 0.4)",
            transition: "all 0.3s ease",
          }}
        >
          🔁 Reveal Another Tile
        </button>
      </Link>

      {/* 🔐 LEGAL DISCLAIMER */}
      <p
        style={{
          fontSize: "12px",
          color: "#777",
          marginTop: "12px",
          maxWidth: "400px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        All purchases are final. No refunds. Tile unlocks are randomized and may not immediately change what you see.
      </p>

      <p
        style={{
          fontSize: "12px",
          color: "#777",
          marginTop: "8px",
          maxWidth: "400px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Link to="/terms" style={{ color: "#ff99cc", textDecoration: "underline" }}>
          View Terms & Conditions
        </Link>
      </p>

      <p
        style={{
          fontSize: "12px",
          color: "#777",
          marginTop: "4px",
          maxWidth: "400px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <Link to="/privacy" style={{ color: "#ff99cc", textDecoration: "underline" }}>
          View Privacy Policy
        </Link>
      </p>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "12px",
              maxWidth: "90%",
              width: "640px",
              boxShadow: "0 0 20px rgba(255, 0, 170, 0.4)",
              textAlign: "center",
              position: "relative",
            }}
          >
            <h3 style={{ fontSize: "20px", marginBottom: "20px", color: "#111" }}>
              Be the first to see the full face.
            </h3>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSevuL_lI574d7qMuLPVa8vHrl_yDyZiRnDc14PijKgzQwa5-A/viewform?embedded=true"
              width="100%"
              height="600"
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Email Capture"
              style={{
                border: "none",
                borderRadius: "8px",
              }}
            >
              Loading…
            </iframe>
            <button
              onClick={() => setShowModal(false)}
              style={{
                marginTop: "20px",
                backgroundColor: "#000",
                color: "#ff69b4",
                border: "none",
                padding: "10px 24px",
                fontSize: "15px",
                borderRadius: "30px",
                cursor: "pointer",
                boxShadow: "0 0 12px #ff00cc, 0 0 20px #39ff14",
                fontWeight: "bold",
                transition: "transform 0.2s ease",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              Back to the mystery
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
